import type {
  Feature2ChargingCommandStatusResponse,
  Feature2ChargingKeysResponse,
  Feature2ChargingStartResponse,
  Feature2ChargingStopRequest,
  Feature2ChargingStopResponse,
} from '../types/feature2-charging-steering.types'
import apiClient from './api-client'

export async function startFeature2Charging(vin: string): Promise<Feature2ChargingStartResponse> {
  const encodedVin = encodeURIComponent(vin)
  const { data } = await apiClient.post<Feature2ChargingStartResponse>(
    `/v1/feature2/vehicles/${encodedVin}/charging/start`,
  )
  return data
}

export async function stopFeature2Charging(
  vin: string,
  request?: Feature2ChargingStopRequest,
): Promise<Feature2ChargingStopResponse> {
  const encodedVin = encodeURIComponent(vin)
  const { data } = await apiClient.post<Feature2ChargingStopResponse>(
    `/v1/feature2/vehicles/${encodedVin}/charging/stop`,
    request ?? {},
    { headers: { 'Content-Type': 'application/json' } },
  )
  return data
}

export async function fetchFeature2ChargingCommandStatus(
  commandId: string,
): Promise<Feature2ChargingCommandStatusResponse> {
  const encodedCommandId = encodeURIComponent(commandId)
  const { data } = await apiClient.get<Feature2ChargingCommandStatusResponse>(
    `/v1/feature2/charging/status/${encodedCommandId}`,
  )
  return data
}

export async function fetchFeature2ChargingKeys(
  vin: string,
): Promise<Feature2ChargingKeysResponse> {
  const encodedVin = encodeURIComponent(vin)
  const { data } = await apiClient.get<Feature2ChargingKeysResponse>(
    `/v1/feature2/vehicles/${encodedVin}/charging/keys`,
  )
  return data
}
